export const ProjectsAnchor = "projects";